<section class="container">

  <div class="row">
    <div class="col">
      <h3>Limite por agente financeiro <small *ngIf="model?.id" class="text-muted">(#ID: {{model.id}})</small></h3>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary"
      (click)="voltarParaLista ()"> Voltar
      </button>
    </div>
  </div>

  <div class="row">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="col nav-tabs">

      <li [ngbNavItem]>
        <a ngbNavLink>Limite Atual</a>
        <ng-template ngbNavContent>

          <div class="row">
            <div class="bn-form-group col-md-8">
              <label for="agenteFinanceiro"><b>Agente Financeiro</b>
              </label>
              <select class="form-select" name="agenteFinanceiro"
                    [(ngModel)]="model?.agenteFinanceiro.id" disabled>
                      <option value="" 			></option>
                      <option [value]="agente.id" *ngFor="let agente of agentesFinanceiros">
                        {{agente.nome}} - ({{agente.cnpj | bnCnpj}})</option>
              </select>
            </div>
            <div class="bn-form-group col-md-4">
              <label for="tranche"><b>Cesta</b></label>
              <select class="form-select" name="tranche"
                [ngModel]="model?.ideTranche" (ngModelChange)="model.ideTranche=$event" disabled >
                  <option value="" 			></option>
                  <option [value]="tranche.id" *ngFor="let tranche of tranches">
                    {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
                </select>
            </div>
            <div class="bn-form-group col-md-4">
              <label><b>Limite de contratação</b></label>
              <input type="text" class="form-control text-end" name="valorLimiteTotal"
              [(ngModel)]="model?.valorLimite.valorLimiteTotal" bnMask="MOEDA" disabled/>
            </div>
          </div>

        </ng-template>
      </li>

      <li [ngbNavItem]>
        <a ngbNavLink>Histórico</a>
        <ng-template ngbNavContent>
          <div class="alert alert-info container" *ngIf="!model.historicoLimite.length; else mostraHistorico">
            Não há histórico para exibição.
          </div>
          <ng-template #mostraHistorico>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">Data</th>
                    <th scope="col">Valor Limite Contratação</th>
                    <!-- <th *ngIf="trancheSelecionada.indicadorLimiteEspecialHabilitado" scope="col">Valor Limite Especial</th>
                    <th *ngIf="trancheSelecionada.indicadorLimiteEspecialHabilitado" scope="col">Valor Limite Inicial</th>
                    <th *ngIf="trancheSelecionada.indicadorLimiteEspecialHabilitado" scope="col">Valor Limite Máximo</th> -->
                    <th scope="col">Responsável</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let limite of model.historicoLimite">
                    <td>{{limite.dataCriacao | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{limite.valorLimiteContratacao | bnMask: 'MOEDA'}}</td>
                    <td *ngIf="trancheSelecionada.indicadorLimiteEspecialHabilitado">{{limite.valorLimiteEspecial | bnMask: 'MOEDA'}}</td>
                    <td *ngIf="trancheSelecionada.indicadorLimiteEspecialHabilitado">{{limite.valorLimiteInicial | bnMask: 'MOEDA'}}</td>
                    <td *ngIf="trancheSelecionada.indicadorLimiteEspecialHabilitado">{{limite.valorLimiteMaximo | bnMask: 'MOEDA'}}</td>
                    <td>{{limite.usuarioResponsavel}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
</section>
